<template>
	<!-- 新增/编辑界面 -->
	<el-drawer :title="title" :visible.sync="editFormVisible" @click="closeDialog" :size="600" class="margin_top_40"
		:wrapperClosable="false" :modal='false' :destroy-on-close='true'>
		<el-form label-width="8.75rem" :model="editForm" :rules="rules" ref="editForm" class="demo-form-inline">
			<el-form-item label="字典编号" prop="dicCode">
				<el-input :disabled="isDisabled" size="small" v-model="editForm.dicCode" auto-complete="off"
					placeholder="请输入字典编号" class="input_200px">
				</el-input>
			</el-form-item>
			<el-form-item label="字典名称" prop="dicText">
				<el-input size="small" v-model="editForm.dicText" auto-complete="off" placeholder="请输入字典名称"
					class="input_200px">
				</el-input>
			</el-form-item>
			<el-form-item label="字典描述" prop="desc">
				<el-input size="small" v-model="editForm.desc" auto-complete="off" placeholder="请输入字典描述"
					class="input_200px">
				</el-input>
			</el-form-item>
			<el-form-item label="显示顺序" prop="seq">
				<el-input size="small" v-model.number="editForm.seq" auto-complete="off" placeholder="请输入显示顺序"
					class="input_200px">
				</el-input>
			</el-form-item>
			<el-form-item label="所属子系统" prop="subSystem">
				<el-select size="small" filterable clearable v-model="editForm.subSystem" placeholder="请选择"
					class="input_200px">
					<el-option v-for="(item, index) in subSystem" :label="item.dicText" :value="item.dicCode"
						:key="index">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="图标">
				<ImageListUpload class="input_200px" v-model="fileList" :fileLimit="1" @input="handleInput" />
			</el-form-item>
		</el-form>
		<div class="drawer-footer">
			<el-button size="small" icon="el-icon-check" :loading="saveloading" class="title" @click="submitForm('editForm')">
				保存
			</el-button>
		</div>
	</el-drawer>
</template>

<script>
	import {
		GetDicDataListByParentCode,
		GetDicDataByKeyId,
		SaveDicData,
	} from '../../../api/dicDataApi.js';
	import ImageListUpload from "@/components/ImageListUpload.vue";
	export default {
		data() {
			return {
				title: '',
				loading: false,
				saveloading: false,
				editFormVisible: false, //控制编辑页面显示与隐藏
				subSystem: [], //所属子系统下拉数据
				isDisabled: false,
				// 编辑表单
				editForm: {
					dicCode: '',
					dicText: '',
					desc: '',
					parentCode: '',
					path: '',
					subSystem: '',
					keyId: '',
					seq: '',
					fileContent: ''
				},
				rules: {
					dicCode: [{
						required: true,
						message: '请输入字典编号',
						trigger: 'blur',
					}, ],
					dicText: [{
						required: true,
						message: '请输入字典名称',
						trigger: 'blur',
					}, ],
					seq: [{
						required: true,
						message: '请输入显示顺序',
						trigger: 'blur',
					}, ],
				},
				fileList: []
			};
		},
		computed: {},
		watch: {},

		methods: {
			// 下拉子系统数据
			getSysData() {
				this.loading = true;
				let parameter = {
					parentCode: 'SubSystem',
				};
				GetDicDataListByParentCode(parameter)
					.then((res) => {
						this.loading = false;
						this.subSystem = res.data;
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error('加载失败，请稍后再试！');
					});
			},
			
			handleInput(file) {
				if (file.length > 0) {
					this.editForm.fileContent = JSON.stringify(file);
				} else {
					this.editForm.fileContent = '';
				}
			},
			
			//显示编辑界面
			handleEdit(row) {
				this.fileList = [];
				this.isDisabled = false;
				if (this.title == '新增子节点') {
					this.$data.editForm = this.$options.data.call(this).editForm
					this.editForm.dicCode = `${row.dicCode}_`
					this.editForm.parentCode = row.dicCode
					this.editFormVisible = true;
				} else if (row != undefined && row != 'undefined') {
					this.title = '编辑';
					this.isDisabled = true;
					let parameter = {
						keyId: row.keyId,
					};
					GetDicDataByKeyId(parameter)
						.then((res) => {
							if (res.code === 1) {
								this.editForm = res.data
								if (res.data.fileContent === "" || res.data.fileContent === null) {} else {
									this.fileList = JSON.parse(res.data.fileContent)
								}
								this.editFormVisible = true;
							} else {
								this.$message.error(res.msg);
							}
						})
						.catch((err) => {
							this.loading = false;
							this.$message.error('加载失败，请稍后再试！');
						});
				} else {
					this.title = '新增';
					this.loading = false;
					this.$data.editForm = this.$options.data.call(this).editForm
					this.editFormVisible = true;
				}
			},
			// 编辑、增加页面保存方法
			submitForm(editData) {
				this.$refs[editData].validate((valid) => {
					if (valid) {
						this.saveloading = true;
						SaveDicData(this.editForm)
							.then((res) => {
								if (res.code == 1) {
									this.editFormVisible = false;
									this.$message({
										type: 'success',
										message: '保存成功！',
									});
									if (this.$parent.name) {
										setTimeout(() => {
											this.$parent.getListData2();
										}, 500);
									} else {
										setTimeout(() => {
											this.$parent.getListData();
										}, 500);
									}
									this.saveloading = false;
								} else {
									this.$message({
										type: 'info',
										message: res.msg,
									});
									this.saveloading = false;
								}
							})
							.catch((err) => {
								this.editFormVisible = false;
								this.saveloading = false;
								this.$message.error('保存失败，请稍后再试！');
							});
					} else {
						return false;
					}
				});
			},
			// 关闭编辑、增加弹出框
			closeDialog() {
				this.editFormVisible = false;
				this.$refs['editForm'].resetFields();
			},
		},
		created() {
			this.getSysData();
		},
		mounted() {},
		components: {
			ImageListUpload
		},
	};
</script>
<style scoped>
</style>